import { ErrorDialog } from "@codat/orchard-ui";
import { datadogRum } from "@datadog/browser-rum";
import { useUserState } from "portal-ui-remote/UserStateContext";
import React, { useEffect } from "react";

function NotFound() {
  const { userState } = useUserState();

  useEffect(() => {
    datadogRum.addError(new Error("404 - Page not found."), {
      path: window.location.pathname,
    });
  }, []);

  return (
    <ErrorDialog
      statusCode={404}
      supportRequestFormOptions={{
        email: userState?.email,
        subject: "Broken link",
      }}
    />
  );
}

export default NotFound;
